import type { UseSchemaBuilderExpressionFormulaProps } from "./schema-builder-expression-formula.type";

import { parseExpressionFormula } from "../schema-builder-expression.helper";
import { useSchemaBuilderExpressionForm } from "../schema-builder-expression.hook";

export const useSchemaBuilderExpressionFormula = ({
  name,
}: UseSchemaBuilderExpressionFormulaProps) => {
  const { setVariables, updateVariables } = useSchemaBuilderExpressionForm({
    name,
  });

  const onChange = (formula?: string) => {
    if (!formula) {
      setVariables([]); // reset
      return;
    }

    const { variables: newVariables } = parseExpressionFormula(formula);

    if (newVariables) updateVariables(newVariables);
  };

  return {
    onChange,
  };
};
